/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {defineMessage} from 'react-intl'

/** ARIA label for refinement pickers when the option has not been selected. */
export const ADD_FILTER = defineMessage({
    id: 'product_list.refinements.button.assistive_msg.add_filter',
    defaultMessage: 'Add filter: {label}'
})

/** ARIA label for refinement pickers when the option has been selected. */
export const REMOVE_FILTER = defineMessage({
    id: 'product_list.refinements.button.assistive_msg.remove_filter',
    defaultMessage: 'Remove filter: {label}'
})

/**
 * ARIA label for refinement pickers when the option has not been selected.
 * Includes the number of results.
 */
export const ADD_FILTER_HIT_COUNT = defineMessage({
    id: 'product_list.refinements.button.assistive_msg.add_filter_with_hit_count',
    defaultMessage: 'Add filter: {label} ({hitCount})'
})

/**
 * ARIA label for refinement pickers when the option has not been selected.
 * Includes the number of results.
 */
export const REMOVE_FILTER_HIT_COUNT = defineMessage({
    id: 'product_list.refinements.button.assistive_msg.remove_filter_with_hit_count',
    defaultMessage: 'Remove filter: {label} ({hitCount})'
})

/** Predefined messages and IDs for each refinement category */
export const ALL_FILTERS_MESSAGE = defineMessage({
    defaultMessage: 'All Filters',
    id: 'product_list.button.allFilters'
})

export const PRICE_MESSAGE = defineMessage({
    defaultMessage: 'Price',
    id: 'product_list.button.price'
})

export const SIZE_MESSAGE = defineMessage({
    defaultMessage: 'Size',
    id: 'product_list.button.size'
})

export const COLOUR_MESSAGE = defineMessage({
    defaultMessage: 'Colour',
    id: 'product_list.button.colour'
})
